"use client";

import { useEffect } from "react";

export default function CrispScript() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Initialize Crisp
    (window as any).$crisp = [];
    (window as any).CRISP_WEBSITE_ID = "f8249dcc-6a44-4b0d-8204-3f8a0bcb773a";

    // Load Crisp script
    (function () {
      const d = document;
      const s = d.createElement("script");
      s.src = "https://client.crisp.chat/l.js";
      s.async = true;
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  }, []);
  return null;
}

